import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksLogsRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-logs',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/logs',
	exact: true,
};
